import clsx from "clsx";
import {
  FormControlLabel,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
  RadioGroupProps as MuiRadioGroupProps,
  RadioProps as MuiRadioProps,
  makeStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import { InputWrapper, InputWrapperProps } from "~components/InputWrapper";

type RadioGroupProps = {
  items: {
    label: string;
    value: number | string;
  }[];
} & MuiRadioGroupProps &
  InputWrapperProps;

type RadioProps = {} & MuiRadioProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radio: {
      padding: 0,

      "&:hover": {
        backgroundColor: "transparent !important",
      },

      "&:disabled": {
        background: theme.palette.background.default,
      },
    },
    labelRoot: {
      margin: 0,

      "&:last-child": {
        marginBottom: 0,
      },
    },
    label: {
      fontSize: 16,
      fontWeight: "normal",
      lineHeight: 1,
      color: theme.palette.dark.main,

      marginLeft: theme.spacing(2),
    },
    icon: {
      backgroundColor: "white",
      height: 24,
      width: 24,

      borderRadius: 999,

      boxShadow: `0 0 0 1px ${theme.palette.blueGrey.main}`,

      "input:enabled:hover ~ &": {
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}, 0 4px 8px 0 rgba(26, 99, 171, 0.16), 0 0 1px 0 rgba(26, 99, 171, 0.08)`,
      },
      "input:enabled:focus ~ &": {
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}, 0 4px 8px 0 rgba(26, 99, 171, 0.16), 0 0 1px 0 rgba(26, 99, 171, 0.08)`,
      },
    },
    checkedIcon: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",

      "&:before": {
        content: '""',
        display: "block",
        width: 14,
        height: 14,

        borderRadius: 999,

        backgroundColor: theme.palette.primary.main,
      },
    },
  }),
);

export const Radio = ({ ...rest }: RadioProps) => {
  const classes = useStyles();
  return (
    <MuiRadio
      disableFocusRipple
      className={classes.radio}
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...rest}
    />
  );
};

export const RadioGroup = ({ items, id, label, error, ...rest }: RadioGroupProps) => {
  const customId = `radioGroup-${id ?? label}`;
  const classes = useStyles();
  return (
    <InputWrapper id={customId} label={label} error={error}>
      <MuiRadioGroup {...rest} id={customId}>
        {items.map((item) => (
          <FormControlLabel
            key={item.value}
            control={<Radio />}
            {...item}
            classes={{ root: classes.labelRoot, label: classes.label }}
          />
        ))}
      </MuiRadioGroup>
    </InputWrapper>
  );
};
